var map = {
	"./ion-action-sheet.entry.js": [
		544,
		157
	],
	"./ion-alert.entry.js": [
		545,
		158
	],
	"./ion-app_8.entry.js": [
		546,
		159
	],
	"./ion-avatar_3.entry.js": [
		547,
		169
	],
	"./ion-back-button.entry.js": [
		548,
		170
	],
	"./ion-backdrop.entry.js": [
		549,
		195
	],
	"./ion-button_2.entry.js": [
		550,
		171
	],
	"./ion-card_5.entry.js": [
		551,
		172
	],
	"./ion-checkbox.entry.js": [
		552,
		173
	],
	"./ion-chip.entry.js": [
		553,
		174
	],
	"./ion-col_3.entry.js": [
		554,
		196
	],
	"./ion-datetime_3.entry.js": [
		555,
		162
	],
	"./ion-fab_3.entry.js": [
		556,
		175
	],
	"./ion-img.entry.js": [
		557,
		197
	],
	"./ion-infinite-scroll_2.entry.js": [
		558,
		198
	],
	"./ion-input.entry.js": [
		559,
		176
	],
	"./ion-item-option_3.entry.js": [
		560,
		177
	],
	"./ion-item_8.entry.js": [
		561,
		178
	],
	"./ion-loading.entry.js": [
		562,
		179
	],
	"./ion-menu_3.entry.js": [
		563,
		180
	],
	"./ion-modal.entry.js": [
		564,
		160
	],
	"./ion-nav_2.entry.js": [
		565,
		166
	],
	"./ion-popover.entry.js": [
		566,
		161
	],
	"./ion-progress-bar.entry.js": [
		567,
		181
	],
	"./ion-radio_2.entry.js": [
		568,
		182
	],
	"./ion-range.entry.js": [
		569,
		183
	],
	"./ion-refresher_2.entry.js": [
		570,
		163
	],
	"./ion-reorder_2.entry.js": [
		571,
		168
	],
	"./ion-ripple-effect.entry.js": [
		572,
		199
	],
	"./ion-route_4.entry.js": [
		573,
		184
	],
	"./ion-searchbar.entry.js": [
		574,
		185
	],
	"./ion-segment_2.entry.js": [
		575,
		186
	],
	"./ion-select_3.entry.js": [
		576,
		187
	],
	"./ion-slide_2.entry.js": [
		577,
		200
	],
	"./ion-spinner.entry.js": [
		578,
		165
	],
	"./ion-split-pane.entry.js": [
		579,
		201
	],
	"./ion-tab-bar_2.entry.js": [
		580,
		188
	],
	"./ion-tab_2.entry.js": [
		581,
		167
	],
	"./ion-text.entry.js": [
		582,
		189
	],
	"./ion-textarea.entry.js": [
		583,
		190
	],
	"./ion-toast.entry.js": [
		584,
		191
	],
	"./ion-toggle.entry.js": [
		585,
		164
	],
	"./ion-virtual-scroll.entry.js": [
		586,
		202
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 415;
module.exports = webpackAsyncContext;